import { HEADER_HEIGHT } from "common/constants";
import { useLayoutEffect, useRef, useState } from "react";
import { throttle } from "utils/throttle";

export const useScrollVisibility = (threshold = HEADER_HEIGHT) => {
  const [isVisible, setIsVisible] = useState(true);
  const previousScrollPosition = useRef(0);

  useLayoutEffect(() => {
    const handleScroll = throttle(() => {
      const currentScrollPosition = window.scrollY;

      const isBelowThreshold = currentScrollPosition <= threshold;
      const isScrollingUp =
        currentScrollPosition < previousScrollPosition.current;

      if (isBelowThreshold || isScrollingUp) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }

      previousScrollPosition.current = currentScrollPosition;
    }, 100);

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, [threshold]);

  return isVisible;
};
